import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HeroSection5 from "./HeroSection5";
import FeatureSection5 from "./FeatureSection5";
import Contact from "../../Components/Contact/Contact";
import Footer from "../../Components/Footer/Footer";

const App5Page = () => {
  useEffect(() => {
    // Add 'biolingo-page' class to <body> for page-specific styles
    document.body.classList.add("sc-chat-page");

    // Update the page title
    const previousTitle = document.title;
    document.title = "SC Chat Analyzer - Optimise the way how you communicate with others| Galaxy Advisors";

    // Scroll to the top of the page when this component loads
    window.scrollTo(0, 0);

    // Cleanup on component unmount
    return () => {
      document.body.classList.remove("sc-chat-page");
      document.title = previousTitle; // Restore the previous title
    };
  }, []);

  return (
    <div>
      {/* SEO Metadata for Social Sharing and Search Engines */}
      <Helmet>
        <title>SC Chat Analyzer - Optimise the way how you communicate with others | Galaxy Advisors</title>
        <meta name="description" content="Discover SC Chat Analyzer - Giving you control over your digital self, your relationships and emotions." />
        <meta property="og:title" content="SC Chat Analyzer - Improve your wellbeing" />
        <meta property="og:description" content="SocialCompass gives you a tool that is incorruptible, accurate and helps you learn more about yourself, discover new viewpoints, and learn how to improve relationships." />
        <meta property="og:image" content="https://galaxyadvisors.com/scPagePreview.png" />
        <meta property="og:url" content="https://galaxyadvisors.com/chatAnalyzer" />
      </Helmet>

      {/* Modularized Sections */}
      <HeroSection5 />
      <FeatureSection5 />
      <Contact />
      <Footer />
    </div>
  );
};

export default App5Page;